import { useSelector } from "react-redux";
import { getCurrentWeekForUrl } from "../store/slices/time";
import Util from "../util/util";
import useIsLoading from "./queryResults/useIsLoading";
import useLeagueSeason from "./queryResults/useLeagueSeason";
import useTeam from "./queryResults/useTeam";
import useUserTeam from "./queryResults/useUserTeam";
import useWeek from "./queryResults/useWeek";

export default function useTeamLinks() {
  const currentWeekForUrl = useSelector(getCurrentWeekForUrl);
  const { league, leagueSeason, leagueQuery } = useLeagueSeason();
  let { team, teamsQuery } = useTeam();
  const userTeam = useUserTeam();
  const { selectedWeek } = useWeek();

  const isLoading = useIsLoading(
    teamsQuery,
    userTeam,
    league,
    leagueSeason,
    leagueQuery
  );
  if (isLoading) {
    return [];
  }

  let teamHomeName = null;
  if (team) teamHomeName = team.fullName;

  if (userTeam && !team) {
    team = userTeam;
    teamHomeName = "team home";
  }

  if (!team) {
    return [];
  }

  const userIsHome = userTeam.obj.id === team.obj.id;

  const leagueIdOrSlug = league.getIdOrSlug();
  const teamIdOrSlug = team.idOrSlug;
  const { season } = leagueSeason.obj;
  let weekUrl = null;
  if (selectedWeek) weekUrl = Util.weekToUrl(selectedWeek);

  const teamPathWithWeek = team.getPath({ week: currentWeekForUrl });
  const teamPathNoWeek = teamPathWithWeek.replace(/\/wk-\d+/, "");

  const makeLink = (label, routeAfterBase = "", useWeek = true) => {
    const base = useWeek ? teamPathWithWeek : teamPathNoWeek;
    const route = `${base}${routeAfterBase}`;
    return { route, label };
  };

  const myHomeLink = {
    route: `/${leagueIdOrSlug}/${season}/${userTeam.idOrSlug}/${weekUrl}`,
    label: "my team home",
  };
  const homeLink = makeLink(teamHomeName);
  const gamesLink = {
    route: `/${leagueIdOrSlug}/${season}/${teamIdOrSlug}/games`,
    label: "games",
  };
  const rosterLink = makeLink("roster", "/roster", false);

  // const lineupLink = {
  //   route: `/${leagueIdOrSlug}/${season}/${teamIdOrSlug}/lineup/${weekUrl}`,
  //   label: "lineup",
  // };
  // const tradesLink = makeLink("trades", "/trades", false);

  const links = [];
  if (!userIsHome) links.push(myHomeLink);

  return links.concat([homeLink, rosterLink, gamesLink]);
}
